import { getNativeCurrencyIcon } from "../../utils/currency";
import { chainIdToNetworkType } from "../chain";
export const CurrencyLogo = ({ chainId, size, ...props }) => {
    var _a;
    const platform = (_a = chainIdToNetworkType(chainId)) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    if (!platform)
        return null;
    return getNativeCurrencyIcon(platform, size, props);
};
